import isFacetedNavPage from "./isFacetedNavPage";
import {
  composeCategoryNavigationLinks,
  composeFacetedNavigationLinks,
  composeRelatedCategoriesLinks,
} from "../helpers";

const getCategorySeoLinks = (state) => {
  const facetedFlag = isFacetedNavPage(state);

  const categoryNavigationLinks = composeCategoryNavigationLinks(state);

  const facetedNavigationLinks = composeFacetedNavigationLinks(state);

  const relatedCategoriesLinks = composeRelatedCategoriesLinks(state);

  return {
    primarySeoLinks: facetedFlag
      ? facetedNavigationLinks
      : categoryNavigationLinks,
    secondarySeoLinks: facetedFlag
      ? categoryNavigationLinks
      : facetedNavigationLinks,
    relatedCategoriesLinks,
  };
};

export default getCategorySeoLinks;
